import React, { useRef } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import MedicalLogEPSCoverPage from './MedicalLogCoverPage';
import { useOnScrollToTop } from 'hooks/useScrollToTop';
import { IStore } from 'redux/store';

type OwnProps = {
	vesselId: string;
    selectedDate?: string;
};
type MedicalLogInspectorViewProps = PropsFromRedux & OwnProps;
function MedicalLogInspectorView(props: MedicalLogInspectorViewProps) {
    const { selectedDate, vesselId } = props;
    const topDivRef = useRef<HTMLDivElement | null>(null);
    useOnScrollToTop(topDivRef);
    return (
        <div className="w-full">
            <div className="h-0" ref={topDivRef} />
            <MedicalLogEPSCoverPage vesselId={vesselId} selectedDate={selectedDate} />
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(MedicalLogInspectorView);
